module.exports = __webpack_public_path__ + "static/media/church-main.62f35c29.jpg";